import { ChangeDetectorRef, Component } from "@angular/core";
import { take } from "rxjs/operators";

import { PanelService } from "@sharedV11/services/panel/panel.service";
import { AccessControlKuroiService } from "@sharedV11/services/api/access-control-kuroi.service";
import { HttpErrorsService } from "@sharedV11/services/alerts/errors/http-errors.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditAccessControlKuroiComponent } from "./edit-access-control-kuroi/edit-access-control-kuroi.component";
import { AccessControlKuroi } from "@sharedV11/types/access-control-kuroi.model";

@Component({
  selector: "app-access-control-kuroi",
  templateUrl: "./access-control-kuroi.component.html",
  styleUrls: ["./access-control-kuroi.component.scss"],
})
export class AccessControlKuroiComponent extends SuperClassComponent {
  panelData: { sourceRecord?: AccessControlKuroi } | null = null;

  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef,
    private accessControlService: AccessControlKuroiService,
    private httpErrorsService: HttpErrorsService
  ) {
    super(panelService, cdRef);
  }

  openPanel() {
    this.panelData = null;
    this.customanpanel = EditAccessControlKuroiComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }

  duplicateRecord(record: AccessControlKuroi | Event | null): void {
    const source = record as AccessControlKuroi | undefined;
    const pkId =
      source?.pkId ??
      (source as any)?.PkId ??
      (source as any)?.pkID ??
      (source as any)?.pkid;

    if (!pkId && !source) {
      return;
    }

    if (!pkId) {
      this.openDuplicatePanel(source as AccessControlKuroi);
      return;
    }

    this.accessControlService
      .getAccesoKuroiById(String(pkId))
      .pipe(take(1))
      .subscribe({
        next: (registro) =>
          this.openDuplicatePanel(registro ?? (source as AccessControlKuroi)),
        error: (error) => this.httpErrorsService.identificarErrores(error),
      });
  }

  private openDuplicatePanel(payload: AccessControlKuroi | null): void {
    if (!payload) {
      return;
    }
    this.panelData = { sourceRecord: payload };
    this.customanpanel = EditAccessControlKuroiComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}

